import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import Alert from "../components/alert";

const OrderServerRequest = function(result) {
  this.disable();
  axios
    .post("/payment/orders", {
      stripeToken: result.id,
      stripeEmail: result.email,
      order: {
        quantity: this.state.quantity
      }
    })
    .then(successHandler.bind(this))
    .catch(errorHandler.bind(this));
};

const successHandler = function(response) {
  ReactDOM.render(
    <Alert type="success" message={response.data.message} />,
    document.getElementById("alerts")
  );
  this.enable();
};

const errorHandler = function(error) {
  if (error.response) {
    ReactDOM.render(
      <Alert type="danger" message={error.response.data.error} />,
      document.getElementById("alerts")
    );
  }
  this.enable();
};

export default OrderServerRequest;
